import script from "./Sales.vue?vue&type=script&setup=true&lang=js"
export * from "./Sales.vue?vue&type=script&setup=true&lang=js"

import "./Sales.vue?vue&type=style&index=0&id=86f15cba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86f15cba"]])

export default __exports__